import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, ChevronLeft, ChevronRight } from 'lucide-react';

const ReviewSlideshow = ({ reviews }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % reviews.length);
    }, 6000);
    return () => clearInterval(timer);
  }, [reviews.length]);

  const next = () => setCurrentIndex((prev) => (prev + 1) % reviews.length);
  const prev = () => setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length);

  if (!reviews || reviews.length === 0) return null;

  return (
    <div className="relative max-w-4xl mx-auto px-4">
      <div className="overflow-hidden relative min-h-[400px] flex items-center">
        <AnimatePresence mode="wait">
          <motion.div
            key={currentIndex}
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -20 }}
            transition={{ duration: 0.5, ease: "easeInOut" }}
            className="w-full text-center"
          >
            <div className="flex justify-center mb-8">
              {[...Array(reviews[currentIndex].stars || 5)].map((_, i) => (
                <Star key={i} className="w-6 h-6 fill-amber-500 text-amber-500 mx-0.5" />
              ))}
            </div>
            
            <blockquote className="text-base font-serif italic text-stone-900 mb-10 leading-relaxed">
              “{reviews[currentIndex].quote.da || reviews[currentIndex].quote}”
            </blockquote>
            
            <cite className="not-italic">
              <span className="block text-sm uppercase tracking-[0.3em] font-bold text-stone-800">
                — {reviews[currentIndex].name}
              </span>
            </cite>
          </motion.div>
        </AnimatePresence>
      </div>

      {/* Navigation Buttons */}
      <div className="flex justify-center gap-6 mt-12">
        <button
          onClick={prev}
          className="p-3 border border-stone-200 text-stone-800 hover:bg-stone-100 transition-colors rounded-full"
          aria-label="Forrige anmeldelse"
        >
          <ChevronLeft className="w-6 h-6" />
        </button>
        <button
          onClick={next}
          className="p-3 border border-stone-200 text-stone-800 hover:bg-stone-100 transition-colors rounded-full"
          aria-label="Næste anmeldelse"
        >
          <ChevronRight className="w-6 h-6" />
        </button>
      </div>

      {/* Dots */}
      <div className="flex justify-center gap-2 mt-8">
        {reviews.map((_, idx) => (
          <button
            key={idx}
            onClick={() => setCurrentIndex(idx)}
            className={`w-2 h-2 rounded-full transition-all ${
              idx === currentIndex ? 'w-8 bg-stone-700' : 'bg-stone-200'
            }`}
            aria-label={`Gå til anmeldelse ${idx + 1}`}
          />
        ))}
      </div>
    </div>
  );
};

export default ReviewSlideshow;
